import { useId } from "../../utils/useId.js";
function useBaseUiId(idOverride) {
  return useId(idOverride, "base-ui");
}
export {
  useBaseUiId
};
//# sourceMappingURL=useBaseUiId.js.map
